import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Row, Col, Card, Modal, Spinner, Tab, Nav } from "react-bootstrap";
import moment from 'moment';
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { startOfWeek, endOfWeek } from "date-fns";
import { getTimeCardSingleDetails, addOwnTimeSheetData, removeTimeSheetData, generateTimesheetDetails, postReportClientApprovalData, generateTimesheetAction, saveReportApprovalData, addTimesheetManuallyReportData } from '../../../store/actions/TimeCardActions';
import { sendToReviewerData, getNoteData, addNoteData } from '../../../store/actions/TimeCaptureActions';
import { getClientsData } from '../../../store/actions/ClientsActions';
import { getProjectList, getProjectByClientIdList, getProjectActivitiesListData, getAccessableTaskList, getProjectDetailsByIdData } from '../../../store/actions/ProjectActions';
import { globalLoadingAction } from '../../../store/actions/GlobalAction';
import { getSystemUserConfigData, getSystemUserWeekOffData, getSystemUserLeaveManageData } from '../../../store/actions/SystemDefaultActions';
import { AddAppliedLeaveData, getLeaveTypeData, getOwnLeaveCalenderListData } from '../../../store/actions/LeaveAction';
import DateRangeModal from '../Components/DateRangeModal';
import SheetReviewModal from '../Components/SheetReviewModal';
import ChatBox from "../Components/ChatBox";
import TimeCardView from "../Components/TimeCardView";
// import LeaveCalendarView from "../Components/LeaveCalendarView";
import LeaveCardView from "../Components/LeaveCardView";
import UnbilableTab from '../../components/Components/UnbilableTab';
import BilableTab from '../../components/Components/BilableTab';
import AddReportManual from '../Components/AddReportManual';
import ReportTimeCardView from '../Components/ReportTimeCardView';

const ReportTo = (props) => {
    const dispatch = useDispatch();
    const { state } = useLocation();
    const startDateRef = useRef();
    const endDateRef = useRef();
    const leaveStartDateRef = useRef();
    const leaveEndDateRef = useRef();
    const filterRef = useRef();
    const filterRangeRef = useRef();

    let errorsObj = { client: '', project: '', activity: '', task: '', description: '', startDate: '', endDate: '' };
    const [errors, setErrors] = useState(errorsObj);

    let errorsLeaveObj = { type: '', startDate: '', endDate: '' };
    const [leaveErrors, setLeaveErrors] = useState(errorsLeaveObj);

    const [activeTab, setActiveTab] = useState(1);
    const [client, setClient] = useState('');
    const [project, setProject] = useState('');
    const [activity, setActivity] = useState('');
    const [task, setTask] = useState('');
    const [description, setDescription] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [filterType, setFilterType] = useState(2);//0
    const [addModal, setAddModal] = useState(false);

    const [action, setAction] = useState(1);
    const [record, setRecord] = useState(null);
    const [projectStartDate, setProjectStartDate] = useState('');
    const [projectEndDate, setProjectEndDate] = useState('');
    const [isDateRange, setIsDateRange] = useState(false);
    const [reviewModal, setReviewModal] = useState(false);
    const [groupBy, setGroupBy] = useState(true);
    const [cardList, setCardList] = useState([]);
    const [cartDetails, setCartDetails] = useState(null);
    const [billedCardList, setBilledCardList] = useState([]);
    const [billedDetails, setBilledDetails] = useState(null);
    const [unBilledCardList, setUnBilledCardList] = useState([]);
    const [unBilledDetails, setUnBilledDetails] = useState(null);
    const [reportModal, setReportModal] = useState(false);
    const [reportClient, setReportClient] = useState(false);

    //note
    const [message, setMessage] = useState('');
    const [projectId, setProjectId] = useState(null);
    const [noteData, setNoteData] = useState([]);
    const [isNote, setIsNote] = useState(false);
    const [loading, setLoading] = useState(false);
    const [weeklyOff, setWeeklyOff] = useState(false);

    //Leave 
    const [leaveModal, setLeaveModal] = useState(false);
    const [loadingLeave, setLoadingLeave] = useState(false);
    const [leaveType, setLeaveType] = useState('');
    const [leaveDescription, setLeaveDescription] = useState('');
    const [leaveStartDate, setLeaveStartDate] = useState(null);
    const [leaveEndDate, setLeaveEndDate] = useState(null);
    const [manualModal, setManualModal] = useState(false);


    //filter
    const [isFilter, setIsFilter] = useState(false);
    const [filterModal, setFilterModal] = useState(false);
    const [filterClient, setFilterClient] = useState('');
    const [filterProject, setFilterProject] = useState('');
    const [filterUser, setFilterUser] = useState(state.id);
    const [filterStartDate, setFilterStartDate] = useState('');
    const [filterEndDate, setFilterEndDate] = useState('');
    const [filterStartDateRange, setFilterStartDateRange] = useState('');
    const [filterEndDateRange, setFilterEndDateRange] = useState('');
    const [filterBilable, setFilterBilable] = useState('0');

    const [selectedWeekDate, setSelectedWeekDate] = useState(new Date());

    //Big-calender
    const [calenderDate, setCalenderDate] = useState(null);



    useEffect(() => {
        const fetchData = async () => {
            try {
                dispatch(globalLoadingAction(true));
                await dispatch(getSystemUserConfigData(2, props.systemAdmin, props.history));
                await dispatch(getClientsData("", "", "", 1, 0, props.history));
                await dispatch(getProjectList("", "", "", 1, 0, props.systemAdmin, props.history));
                await dispatch(getSystemUserWeekOffData(3, props.systemAdmin, props.history));
                await dispatch(getSystemUserLeaveManageData(4, props.systemAdmin, props.history));
                await dispatch(getLeaveTypeData(props.history));
                await dispatch(getOwnLeaveCalenderListData(props.userId, '', props.history));
            } catch (error) {
                console.error('Error fetching initial data:', error);
            }
        };

        fetchData();

        return () => {
            dispatch(generateTimesheetAction({}));
        };
    }, [dispatch, props.systemAdmin, props.history]);


    useEffect(() => {
        const { data, weekly_off } = props.timeCardDetails || {};
        setWeeklyOff(weekly_off);

        if (!data || typeof data !== 'object') return;

        const hasData = (entry) =>
            entry?.report_data?.[0]?.weeks_table?.[0]?.data_table?.length > 0;

        if (Array.isArray(data)) {
            const validCards = data.filter(hasData);
            setCardList(validCards);
            const output = convertProjectsToFormat(validCards);
            setCartDetails(output ?? null);
        } else {
            if (Array.isArray(data.non_billable_report_data)) {
                const validUnbilled = data.non_billable_report_data.filter(hasData);
                setUnBilledCardList(validUnbilled);
                const output = convertProjectsToFormat(validUnbilled ?? []);
                console.log('output..', output)
                setUnBilledDetails(output ?? null);
            }

            if (Array.isArray(data.report_data)) {
                const validBilled = data.report_data.filter(hasData);
                setBilledCardList(validBilled);
                const output = convertProjectsToFormat(validBilled);
                setBilledDetails(output ?? null);
            }
        }
    }, [props.timeCardDetails]);


    function convertProjectsToFormat(projects) {
        if (!projects.length) return {};

        // pick the time_table from first project's first week
        const timeTable = projects[0].report_data[0].weeks_table[0].time_table;

        let weeksTable = [];
        let totalLeave = 0;
        let totalHour = 0;
        let empRate = 0; // can be overridden if multiple projects differ

        projects.forEach(project => {
            project.report_data.forEach(report => {
                empRate = report.emp_rate; // if multiple, last one will apply
                totalLeave += report.total_leave;
                totalHour += parseFloat(report.total_hour);

                report.weeks_table.forEach(week => {
                    week.data_table.forEach(task => {
                        weeksTable.push({
                            project_id: project.project_id,
                            client_id: project.client_id,
                            project_name: project.project_name,
                            project_unique_id: project.project_unique_id,
                            activity_id: task.activity_id,
                            task_id: task.task_id,
                            total_hour: task.total_hour,
                            time_details: task.time_details
                        });
                    });
                });
            });
        });

        const totalPay = (totalHour * empRate).toFixed(2);

        return {
            time_table: timeTable,
            weeks_table: weeksTable,
            total_leave: totalLeave,
            total_hour: totalHour.toFixed(2),
            total_pay: totalPay,
            emp_rate: empRate
        };
    }


    useEffect(() => {
        if (props.projectDetails?.start_date) {
            setProjectStartDate(new Date(props.projectDetails.start_date));
            setProjectEndDate(new Date(props.projectDetails.end_date));
        }
    }, [props.projectDetails]);

    function onUpdateData(e) {

        e.preventDefault();

        let error = false;
        const errorObj = { ...errorsObj };

        if (client === '') {
            errorObj.client = 'Client is Required';
            error = true;
        }
        if (project === '') {
            errorObj.project = 'Project is Required';
            error = true;
        }
        if (activity === '') {
            errorObj.activity = 'Activity is Required';
            error = true;
        }
        if (task === '') {
            errorObj.task = 'Task is Required';
            error = true;
        }
        if (startDate === '') {
            errorObj.startDate = 'Start date is Required';
            error = true;
        }
        if (endDate === '') {
            errorObj.endDate = 'End date is Required';
            error = true;
        }
        if (startDate >= projectStartDate && endDate >= projectEndDate) {
            setIsDateRange(true);
            error = true;
        }
        if (description === '') {
            errorObj.description = 'Description is Required';
            error = true;
        }

        setErrors(errorObj);
        if (error) {
            return;
        }

        if (action == 1) {
            setAddModal(false);
            setReviewModal(true);
        } else {
            // dispatch(globalLoadingAction(true));
            // dispatch(updateOwnTimeSheetData(
            //     state.id,
            //     record,
            //     client == "0" ? "" : client,
            //     project == "0" ? "" : project,
            //     activity == "0" ? "" : activity,
            //     task == "0" ? "" : task,
            //     description,
            //     startDate,
            //     endDate,
            //     filterType,
            //     true,
            //     filterClient ? filterClient : '',
            //     filterProject ? filterProject : '',
            //     filterType == 3 ? moment(filterStartDate).format('YYYY-MM-DD') : '',
            //     filterType == 3 ? moment(filterEndDate).format('YYYY-MM-DD') : '',
            //     groupBy,
            //     props.history));
            // setAddModal(false);
            // cleanHandler();
        }
    }

    const onFinalSubmitHandler = () => {
        // Get month and year based on filterStartDate or current date
        let month = filterStartDate ? moment(filterStartDate).format('M') : moment().format('M');
        let year = filterStartDate ? moment(filterStartDate).format('YYYY') : moment().format('YYYY'); // Full year

        // Dispatch loading action
        dispatch(globalLoadingAction(true));

        // Dispatch the action to add own timesheet data
        dispatch(addOwnTimeSheetData(
            state.id,
            client === "0" ? "" : client,
            project === "0" ? "" : project,
            activity === "0" ? "" : activity,
            task === "0" ? "" : task,
            description,
            startDate,
            endDate,
            filterType,
            filterType === 1 ? parseInt(month) : '',  // Send as integer for filterType 1
            filterType === 1 ? parseInt(year) : '',
            props.history
        ));

        // Reset modal and clear filters
        setReviewModal(false);
        onClearFilter();
        cleanHandler();
    };



    const onReviewCloseHandler = () => {
        setAddModal(true);
        setReviewModal(false);
    }

    const cleanHandler = () => {
        setClient('');
        setProject('');
        setActivity('');
        setTask('');
        setDescription('');
        setStartDate('');
        setEndDate('');
    }

    const onClientHandler = (val) => {
        setClient(val);
        setProject('');
        setActivity('');
        setTask('');
        dispatch(getProjectByClientIdList(val, props.history));
    }

    const onProjectHandler = (val) => {
        setProject(val);
        setActivity('');
        setTask('');
        if (val) {
            dispatch(getProjectDetailsByIdData(val, props.history));
            dispatch(getProjectActivitiesListData(val, '', '', '', 1, 0, props.systemAdmin, props.history));
        }
    }

    const onActivityHander = (val) => {
        setActivity(val);
        setTask('');
        dispatch(getAccessableTaskList(val, '', props.history));
    }

    const onFilterTypeHandler = (val) => {
        setFilterType(val);
        setSelectedWeekDate(new Date());
        setFilterStartDateRange('');
        setFilterEndDateRange('')
    }

    const onAddHandler = () => {
        const errorObj = { ...errorsObj };
        setErrors(errorObj);
        setRecord('');
        setClient('');
        setProject('');
        setActivity('');
        setTask('');
        setStartDate('');
        setEndDate('');
        setDescription('');
        setAddModal(true);
        setAction(1);
    }

    const onEditHandler = (item) => {
        dispatch(getProjectDetailsByIdData(item.project_id, props.history));
        dispatch(getProjectByClientIdList(item.client_id, props.history));
        dispatch(getProjectActivitiesListData(item.project_id, '', '', '', 1, 0, props.systemAdmin, props.history));
        dispatch(getAccessableTaskList(item.activity_id, '', props.history));
        setRecord(item.time_track_id);
        setClient(item.client_id);
        setProject(item.project_id);
        setActivity(item.activity_id);
        setTask(item.task_id);
        setStartDate(new Date(item.start_time));
        setEndDate(new Date(item.end_time));
        setDescription(item.description);
        setProjectStartDate(new Date(item.project_start_date));
        setProjectEndDate(new Date(item.project_end_date));
        setErrors(errorsObj);
        setAddModal(true);
        setAction(2);
    }

    const onDeleteHandler = (item) => {
        swal({
            title: "Are you sure?",
            text:
                "You want to remove this item !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(globalLoadingAction(true));
                dispatch(removeTimeSheetData(item._id,
                    item.time_track_id,
                    state.id,
                    filterType,
                    true,
                    filterClient ? filterClient : '',
                    filterProject ? filterProject : '',
                    filterType == 3 ? moment(filterStartDate).format('YYYY-MM-DD') : '',
                    filterType == 3 ? moment(filterEndDate).format('YYYY-MM-DD') : '',
                    groupBy,
                    props.history));

            }
        })
    }

    const onFilterClientHandler = (val) => {
        setFilterClient(val);
        setFilterProject('');
        dispatch(getProjectByClientIdList(val, props.history));
        dispatch(globalLoadingAction(true));
        dispatch(getTimeCardSingleDetails(state.id, filterType, true,
            val, '',
            filterType == 3 ? moment.utc(filterStartDate).format('YYYY-MM-DD') : '',
            filterType == 3 ? moment.utc(filterEndDate).format('YYYY-MM-DD') : '', groupBy, props.history));
    }

    const onFilterProjectHandler = (val) => {
        setFilterProject(val);
        setFilterUser('');
        // let month = filterStartDate ? moment(filterStartDate).format('M') : moment().format('M');
        // let year = filterStartDate ? moment(filterStartDate).format('YYYY') : moment().format('YYYY');
        // dispatch(globalLoadingAction(true));
        // dispatch(getTimeCardSingleDetails(
        //     state.id,
        //     filterType ? parseInt(filterType) : 0, 
        //     true,
        //     '',
        //     val,
        //     filterType === 1 ? parseInt(month) : '',
        //     filterType === 1 ? parseInt(year) : '',
        //     filterType === 3 && filterStartDateRange ? moment(filterStartDateRange).format('YYYY-MM-DD') : '',
        //     filterType === 3 && filterEndDateRange ? moment(filterEndDateRange).format('YYYY-MM-DD') : '',
        //     props.history
        // ));

    }

    const onFilterBillableHandler = (val) => {
        setFilterBilable(val);
        setFilterUser('');
    }

    const onFilterUserHandler = (val) => {
        setFilterUser(val);
        let month = filterStartDate ? moment(filterStartDate).format('M') : moment().format('M');
        let year = filterStartDate ? moment(filterStartDate).format('YYYY') : moment().format('YYYY');
        dispatch(globalLoadingAction(true));
        dispatch(getTimeCardSingleDetails(
            val,
            filterType ? parseInt(filterType) : 0, // Ensure filterType is parsed as an integer
            true,
            '',
            filterProject,
            filterType === 1 ? parseInt(month) : '', // Parse month if filterType is 1
            filterType === 1 ? parseInt(year) : '',  // Parse year if filterType is 1
            filterType === 3 && filterStartDateRange ? moment(filterStartDateRange).format('YYYY-MM-DD') : '',
            filterType === 3 && filterEndDateRange ? moment(filterEndDateRange).format('YYYY-MM-DD') : '',
            props.history
        ));

    }

    const onDateRangeFilterHandler = (dates) => {
        const [start, end] = dates;
        setFilterStartDateRange(start);
        setFilterEndDateRange(end);
        if (start && end) {
            // dispatch(globalLoadingAction(true));
            // dispatch(getTimeCardSingleDetails(
            //     state.id, 3, true, '', '', '', '',
            //     moment(start).format('YYYY-MM-DD'),
            //     moment(end).format('YYYY-MM-DD'),
            //     props.history
            // ));
            setFilterStartDate('');
            onClearFilter();
            setFilterType(3);
        }
    }

    const handleWeekSelect = (date) => {
        setSelectedWeekDate(date);

        const start = startOfWeek(date, { weekStartsOn: 0 }); // Sunday
        const end = endOfWeek(date, { weekStartsOn: 0 });     // Saturday

        setFilterStartDateRange(start);
        setFilterEndDateRange(end);
        //setFilterType(3); // set your filter type

        setFilterStartDate('');
        onClearFilter();
        setFilterType(3);
    };

    const onChangeDateFilterHandler = (date) => {
        setFilterStartDate(date);
        if (date) {
            setFilterType(1);
        }
    }

    const formatStartDate = (date) => {
        return date ? date.toLocaleDateString() : ''; // Format the date as per your need
    };

    function onFilterSubmit(e) {
        e.preventDefault();
        dispatch(globalLoadingAction(false));
        dispatch(getTimeCardSingleDetails(state.id, filterType, true,
            filterClient, filterProject,
            filterType == 3 ? moment.utc(filterStartDate).format('YYYY-MM-DD') : '',
            filterType == 3 ? moment.utc(filterEndDate).format('YYYY-MM-DD') : '', groupBy, props.history));
        setFilterModal(false);
        setIsFilter(true);
    }

    const onClearFilterHandler = () => {
        dispatch(globalLoadingAction(false));
        dispatch(getTimeCardSingleDetails(state.id,
            filterType,
            true, '', '',
            filterType == 3 ? moment.utc(filterStartDate).format('YYYY-MM-DD') : '',
            filterType == 3 ? moment.utc(filterEndDate).format('YYYY-MM-DD') : '', groupBy, props.history));
        onClearFilter();
    }

    const onClearFilter = () => {
        setFilterModal(false);
        setFilterClient('');
        setFilterProject('');
        setFilterUser('');
        setIsFilter(false);
    }

    const onAssignHandler = (item) => {
        let array = [];
        item.data.forEach(element => {
            if (element.time_track_id) {
                array.push(element.time_track_id)
            }
        });
        dispatch(globalLoadingAction(true));
        dispatch(sendToReviewerData(item.project_id, array, sendToReviewerCallBack, props.history));
    }

    const sendToReviewerCallBack = () => {
        dispatch(globalLoadingAction(true));
        dispatch(getTimeCardSingleDetails(state.id, filterType, true,
            filterClient, filterProject,
            filterType == 3 ? moment.utc(filterStartDate).format('YYYY-MM-DD') : '',
            filterType == 3 ? moment.utc(filterEndDate).format('YYYY-MM-DD') : '', groupBy, props.history));
    }

    const onSubmitMessageHandler = () => {
        setMessage("");
        setLoading(true);
        dispatch(addNoteData(projectId, message, AddNotData, props.history));
    }

    const AddNotData = (data) => {
        setNoteData(data);
        setLoading(false);
    }

    const onGetNoteHandler = (task_id) => {
        setProjectId(task_id);
        dispatch(globalLoadingAction(true));
        dispatch(getNoteData(task_id, setNotData, props.history));
    }

    const setNotData = (data) => {
        dispatch(globalLoadingAction(false));
        setNoteData(data);
        setIsNote(true);
    }

    const closeHandler = () => {
        setIsNote(false);
        setNoteData([]);
    }

    const onReportHandler = () => {
        let month = filterStartDate ? moment(filterStartDate).format('M') : moment().format('M');
        let year = filterStartDate ? moment(filterStartDate).format('YYYY') : moment().format('YYYY');
        dispatch(globalLoadingAction(true));
        dispatch(postReportClientApprovalData(
            filterProject,
            filterType ? parseInt(filterType) : 0,
            filterType == 1 ? parseInt(month) : '',
            filterType == 1 ? parseInt(year) : '',
            filterType === 3 && filterStartDateRange ? moment(filterStartDateRange).format('YYYY-MM-DD') : '',
            filterType === 3 && filterEndDateRange ? moment(filterEndDateRange).format('YYYY-MM-DD') : '',
            props.timeCardDetails.bill_id,
            '',
            parseInt(filterBilable),
            filterBilable == 0 ? billedCardList : cardList,
            unBilledCardList,
            sendCallBack,
            props.history));
    }

    const onSaveHandler = () => {
        let month = filterStartDate ? moment(filterStartDate).format('M') : moment().format('M');
        let year = filterStartDate ? moment(filterStartDate).format('YYYY') : moment().format('YYYY');
        dispatch(globalLoadingAction(true));
        dispatch(saveReportApprovalData(
            filterProject,
            filterType ? parseInt(filterType) : 0,
            filterType == 1 ? parseInt(month) : '',
            filterType == 1 ? parseInt(year) : '',
            filterType === 3 && filterStartDateRange ? moment(filterStartDateRange).format('YYYY-MM-DD') : '',
            filterType === 3 && filterEndDateRange ? moment(filterEndDateRange).format('YYYY-MM-DD') : '',
            parseInt(filterBilable),
            filterBilable == 0 ? billedCardList : cardList,
            unBilledCardList,
            sendCallBack,
            props.history));
    }

    const onGenerateHandler = () => {
        let projectArry = filterProject
            ? [filterProject]
            : props.projectList.map(project => project._id);
        let month = filterStartDate ? moment(filterStartDate).format('M') : moment().format('M');
        let year = filterStartDate ? moment(filterStartDate).format('YYYY') : moment().format('YYYY');
        dispatch(globalLoadingAction(true));
        dispatch(generateTimesheetDetails(
            state.id,
            filterType ? parseInt(filterType) : 0,
            true,
            '',
            projectArry,
            filterType == 1 ? parseInt(month) : '',
            filterType == 1 ? parseInt(year) : '',
            filterType === 3 && filterStartDateRange ? moment(filterStartDateRange).format('YYYY-MM-DD') : '',
            filterType === 3 && filterEndDateRange ? moment(filterEndDateRange).format('YYYY-MM-DD') : '',
            parseInt(filterBilable),
            props.history
        ));
        if (filterType == 1) {
            setCalenderDate(new Date(moment(filterStartDate).toDate()));
        } else if (filterType == 2) {
            setCalenderDate(new Date());
        } else {
            setCalenderDate(new Date(moment(filterStartDateRange).toDate()));
        }
    }

    function onReportSubmit(e) {
        e.preventDefault();
        let month = filterStartDate ? moment(filterStartDate).format('M') : moment().format('M');
        let year = filterStartDate ? moment(filterStartDate).format('YYYY') : moment().format('YYYY');
        dispatch(globalLoadingAction(true));
        dispatch(postReportClientApprovalData(
            filterProject,
            filterType ? parseInt(filterType) : 0,
            filterType == 1 ? parseInt(month) : '',
            filterType == 1 ? parseInt(year) : '',
            filterType === 3 && filterStartDateRange ? moment(filterStartDateRange).format('YYYY-MM-DD') : '',
            filterType === 3 && filterEndDateRange ? moment(filterEndDateRange).format('YYYY-MM-DD') : '',
            props.timeCardDetails.bill_id,
            reportClient,
            cardList,
            sendCallBack, props.history));

    }
    const sendCallBack = () => {
        setReportModal(false);
    }


    const tabData = [
        {
            id: 1,
            name: "Billable",
            content: <BilableTab
                data={billedDetails}
                config={weeklyOff}
                noteHandler={(id) => onGetNoteHandler(id)}
                reportHandler={() => onReportHandler()}
                saveHandler={() => onSaveHandler()}
                leaveHandler={() => addLeaveHandler()}
                addManualEntryHandler={() => setManualModal(true)}
            />,
        },
        {
            id: 2,
            name: "Non-billable",
            content: <UnbilableTab
                data={unBilledDetails}
                config={weeklyOff}
                noteHandler={(id) => onGetNoteHandler(id)}
                reportHandler={() => onReportHandler()}
                saveHandler={() => onSaveHandler()}
                leaveHandler={() => addLeaveHandler()}
                addManualEntryHandler={() => setManualModal(true)}
            />,
        }
    ];

    const handleTabSelect = (key) => {
        setActiveTab(Number(key)); // Ensure `key` is converted to a number
    };

    const onSubmitLeaveHandler = () => {
        let error = false;
        const errorObj = { ...errorsLeaveObj };

        if (leaveType === '') {
            errorObj.type = 'Leave type is Required';
            error = true;
        }

        if (leaveStartDate === null) {
            errorObj.startDate = 'Start Date is Required';
            error = true;
        }
        if (leaveEndDate === null) {
            errorObj.endDate = 'End Date is Required';
            error = true;
        }

        setLeaveErrors(errorObj);
        if (error) {
            return;
        }
        setLoadingLeave(true);
        dispatch(AddAppliedLeaveData(leaveType, leaveStartDate ? moment(leaveStartDate).format("YYYY-MM-DD") : '', leaveEndDate ? moment(leaveEndDate).format("YYYY-MM-DD") : '', leaveDescription, ListCallBack, props.history));
    }

    const ListCallBack = (response) => {
        if (response) {
            onGenerateHandler();
            setLeaveModal(false);
            dispatch(getOwnLeaveCalenderListData());
        }
        setLoadingLeave(false);

    }

    const addLeaveHandler = () => {
        setLeaveErrors(errorsLeaveObj);
        setLeaveType('');
        setLeaveDescription('');
        setLeaveStartDate(null);
        setLeaveEndDate(null);
        setLeaveModal(true);
    }

    const onManualSubmitHandler = (data) => {
        dispatch(globalLoadingAction(false));
        dispatch(
            addTimesheetManuallyReportData(
                data.project,
                data.activity,
                data.task,
                moment(data.startDate).format("YYYY-MM-DD H:mm:ss"),
                moment(data.endDate).format("YYYY-MM-DD H:mm:ss"),
                data.description,
                props.systemAdmin,
                manualCallBack,
                props.history
            )
        );
    }

    const manualCallBack = () => {
        setManualModal(false);
        onGenerateHandler();
    }


    // const leaveCardProps = useMemo(() => {
    //     let billedTotal = 0;
    //     let unbilledTotal = 0;  
    //     let cardTotal = 0;

    //     // Helper function to safely extract total_hour
    //     const getTotalHour = (element) =>
    //         element?.report_data?.[0]?.weeks_table?.[0]?.total_hour || 0;

    //     // Calculate totals
    //     cardList.forEach(element => {
    //         cardTotal += getTotalHour(element);
    //     });

    //     billedCardList.forEach(element => {
    //         billedTotal += getTotalHour(element);
    //     });

    //     unBilledCardList.forEach(element => {
    //         unbilledTotal += getTotalHour(element);
    //     });

    //     // Determine final totalHour based on filters
    //     const totalHour = filterBilable === 0
    //         ? (activeTab === 1 ? billedTotal : unbilledTotal)
    //         : cardTotal;

    //     return {
    //         userId: props.userId,
    //         filterType,
    //         startDate: filterStartDateRange,
    //         endDate: filterEndDateRange,
    //         isAddLeave: true,
    //         grandHour: totalHour ?? 0,
    //     };
    // }, [billedCardList, unBilledCardList, cardList, activeTab]);

    const leaveCardProps = useMemo(() => {

        const getTotalHour = (element) =>
            Number(element?.report_data?.[0]?.total_hour) || 0;

        const billedTotal = billedCardList.reduce((sum, el) => sum + getTotalHour(el), 0);
        const unbilledTotal = unBilledCardList.reduce((sum, el) => sum + getTotalHour(el), 0);
        const cardTotal = cardList.reduce((sum, el) => sum + getTotalHour(el), 0);

        const totalHour = filterBilable == 0
            ? (activeTab == 1 ? billedTotal : unbilledTotal)
            : cardTotal;

        return {
            userId: props.userId,
            filterType,
            startDate: filterStartDateRange,
            endDate: filterEndDateRange,
            isAddLeave: true,
            grandHour: totalHour,
        };
    }, [billedCardList, unBilledCardList, cardList, activeTab]);




    return (
        <>
            <div className="row">
                <div className="breadcrumb-container">
                    <ul>
                        <li>
                            <Link to={"#"}>Reporting</Link>
                        </li>
                        <li><i className="fa fa-angle-right"></i></li>
                        <li>
                            <Link to={"#"}>Report To</Link>
                        </li>
                    </ul>
                </div>
                <div className="title-body add-leave-btn mb-3">
                    <h3>Weekly Timesheet</h3>
                    {/* <h3>{filterType == 1 ? 'Monthly' : filterType == 2 ? 'Weekly' : filterType == 3 ? 'Date wise' : null} Timesheet</h3> */}
                    {/* {props.configLeave?.filter_option_id == 1 ?
                        <button
                            className="generate-report-btn ms-2 me-0"
                            onClick={() => addLeaveHandler()}
                        >Add Leave</button> : null} */}
                </div>
                <div className="title-body-container">
                    {/* <div className="title-body mb-3">
                        <h3>{filterType == 1 ? 'Monthly' : filterType == 2 ? 'Weekly' : filterType == 3 ? 'Date wise' : null} Timesheet</h3>
                    </div> */}
                    <div className="title-filter-container">
                        <div className="button-filter">
                            <button className="time-sheet-filter-btn" style={{ backgroundColor: filterType == 2 ? '#332d28' : '#7e7c7a' }} onClick={() => onFilterTypeHandler(2)} type='button'>Weekly</button>
                            {/* <div className="time-sheet-filter-date-view">
                                <DatePicker
                                    ref={filterRef}
                                    selected={filterStartDate}
                                    showMonthYearPicker
                                    className="d-none"
                                    onChange={(date) => onChangeDateFilterHandler(date)}
                                    shouldCloseOnSelect={true}
                                    disabledKeyboardNavigation
                                />

                                <button
                                    type="button"
                                    className="time-sheet-filter-date-btn"
                                    style={{ backgroundColor: filterType === 1 ? '#332d28' : '#7e7c7a' }}
                                    onClick={() => filterRef.current.setOpen(true)} // Open datepicker on button click
                                >
                                    {filterStartDate && filterType === 1 ? `${moment(filterStartDate).format('MMMM YYYY')}` : 'Monthly'}

                                </button>
                            </div> */}

                            {/* <div className="time-sheet-filter-date-view">
                                <DatePicker
                                    ref={filterRangeRef}
                                    selected={filterStartDateRange}
                                    className="d-none"
                                    selectsRange
                                    startDate={filterStartDateRange}
                                    endDate={filterEndDateRange}
                                    onChange={(dates) => onDateRangeFilterHandler(dates)}
                                />
                                <button
                                    type="button"
                                    className="time-sheet-filter-date-btn"
                                    style={{ backgroundColor: filterType === 3 ? '#332d28' : '#7e7c7a' }}
                                    onClick={() => filterRangeRef.current.setOpen(true)}
                                >
                                    {filterType === 3 && filterStartDateRange && filterEndDateRange
                                        ? `${moment(filterStartDateRange).format('DD/MM/YY')} - ${moment(filterEndDateRange).format('DD/MM/YY')}`
                                        : 'Date Range'}
                                </button>
                            </div> */}

                            <div className="time-sheet-filter-date-view">
                                <DatePicker
                                    ref={filterRangeRef}
                                    selected={selectedWeekDate}
                                    className="d-none"
                                    dateFormat="I/R"
                                    locale="en-GB"
                                    showWeekNumbers
                                    showWeekPicker
                                    //onChange={(dates) => onDateRangeFilterHandler(dates)}
                                    onChange={(dates) => handleWeekSelect(dates)}
                                />
                                <button
                                    type="button"
                                    className="time-sheet-filter-date-btn"
                                    style={{ backgroundColor: filterType === 3 ? '#332d28' : '#7e7c7a' }}
                                    onClick={() => filterRangeRef.current.setOpen(true)}
                                >
                                    {filterStartDateRange && filterEndDateRange
                                        ? `${moment(filterStartDateRange).format('DD/MM/YY')} - ${moment(filterEndDateRange).format('DD/MM/YY')}`
                                        : 'Select Week'}

                                </button>
                            </div>

                            <div className="form-group card-filter-select me-2">
                                <div className="select-drop-down">
                                    <span><i class="fa fa-angle-down"></i></span>
                                    <select
                                        defaultValue={"option"}
                                        className="form-control select-control"
                                        value={filterProject}
                                        onChange={(e) => onFilterProjectHandler(e.target.value)}>
                                        <option value="">All</option>
                                        {
                                            props.projectList.map((item, index) => {
                                                return <option key={index} value={item._id}>{item.project_id}</option>
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="form-group card-filter-select me-2">
                                <div className="select-drop-down">
                                    <span><i class="fa fa-angle-down"></i></span>
                                    <select
                                        defaultValue={"option"}
                                        className="form-control select-control"
                                        value={filterBilable}
                                        onChange={(e) => onFilterBillableHandler(e.target.value)}>
                                        <option value="0">Both</option>
                                        <option value="1">Billed</option>
                                        <option value="2">Unbilled</option>
                                    </select>
                                </div>
                            </div>
                            <button
                                className="generate-report-btn me-0"
                                onClick={() => onGenerateHandler()}
                            //disabled={!filterProject}
                            >Generate Report</button>

                        </div>

                    </div>

                </div>
                <div className="account-setting-content">
                    <Col lg={12}>
                        <Card className='m-0'>

                            <Card.Body>
                                {props.timeCardDetails?.data ?
                                    <>
                                        {filterBilable == 0 && (billedCardList.length > 0 || unBilledCardList.length > 0) ?
                                            <div className='report-tabview'>
                                                <Tab.Container
                                                    defaultActiveKey={activeTab}
                                                    onSelect={handleTabSelect}
                                                >
                                                    <Nav as="ul" className="nav-pills mb-4 light">
                                                        {tabData.map((data, i) => (
                                                            <Nav.Item as="li" key={i}>
                                                                <Nav.Link eventKey={data.id}>
                                                                    {data.name}
                                                                </Nav.Link>
                                                            </Nav.Item>
                                                        ))}
                                                    </Nav>
                                                    <Tab.Content className="">
                                                        {tabData.map((data, i) => (
                                                            <Tab.Pane
                                                                eventKey={data.id}
                                                                key={i}
                                                            >
                                                                {activeTab === data.id && data.content}
                                                            </Tab.Pane>
                                                        ))}
                                                    </Tab.Content>
                                                </Tab.Container>
                                            </div> :
                                            <>
                                                <div className='report-header-container'>
                                                    {cardList.length > 0 && (
                                                        <div className='report-leave-container'>
                                                            {/* {props.configLeave?.filter_option_id == 1 ?
                                                            <button
                                                                className="add-report-leave-btn"
                                                                onClick={() => addLeaveHandler()}
                                                            >Add Leave</button> : null} */}
                                                            <button
                                                                className="add-report-leave-btn"
                                                                onClick={() => setManualModal(true)}
                                                            >Manual Entry</button>
                                                        </div>)}

                                                    {cardList.length > 0 ?

                                                        <div className='report-header'>

                                                            <button
                                                                type='button'
                                                                className='me-2'
                                                                onClick={() => onReportHandler()}
                                                            >Save & Submit</button>
                                                            <button
                                                                type='button'
                                                                onClick={() => onSaveHandler()}
                                                            >Save</button>
                                                        </div>

                                                        : null}
                                                </div>

                                                {
                                                    cartDetails && Object.keys(cartDetails).length > 0 ? (
                                                        <ReportTimeCardView
                                                            onNoteHandler={(id) => onGetNoteHandler(id)}
                                                            isConfig={weeklyOff}
                                                            projectName=''
                                                            details={cartDetails} />
                                                    ) : (
                                                        <div className="text-center mt-3">
                                                            <h3>No Data Found</h3>
                                                        </div>
                                                    )
                                                }
                                                {/* {cardList.length > 0 ?
                                                    cardList.map((item, index) => {
                                                        return (
                                                            <TimeCardView
                                                                key={index}
                                                                onNoteHandler={(id) => onGetNoteHandler(id)}
                                                                isConfig={weeklyOff}
                                                                projectName={item?.project_name}
                                                                details={item?.report_data[0]} />
                                                        )
                                                    }) 
                                                    :
                                                    <div className='text-center mt-3'><h3>No Data Found</h3></div>} */}
                                            </>
                                        }
                                        <div style={{ marginTop: 40 }}>
                                            <LeaveCardView
                                                generateReport={() => onGenerateHandler()}
                                                {...leaveCardProps} />
                                        </div>
                                    </>
                                    : <div className='text-center mt-3'><h3>No Data Found</h3></div>}
                            </Card.Body>

                        </Card>
                        <div>
                            <p><strong>Note:</strong> Use increments of 0.25 (15 minutes) when recording hours.</p>
                        </div>
                    </Col>
                </div>
            </div>

            <Modal
                className="fade bd-example-modal-sm"
                size="lg"
                show={addModal}
                onHide={() => setAddModal(false)}
            >
                <div className="add-user-modal-form-view client-modal">
                    <button onClick={() => setAddModal(false)} className="modal-cross-btn"><i class="fa fa-times" aria-hidden="true"></i></button>
                    <div className="modal-title-view">
                        <h3>{action == 1 ? "Add" : "Update"} Timesheet</h3>
                    </div>
                    <div className="basic-form">
                        <form onSubmit={onUpdateData}>
                            <div className="row">

                                <div className="form-group form-group-modal-custom mb-3 col-6">
                                    <label className="mb-1">
                                        <strong>Client</strong>
                                    </label>
                                    <div className="select-drop-down">
                                        <span><i class="fa fa-angle-down"></i></span>
                                        <select
                                            defaultValue={"option"}
                                            className="form-control select-control"
                                            value={client}
                                            onChange={(e) => onClientHandler(e.target.value)}>
                                            <option value=""></option>
                                            {
                                                props.clientList.map((item, index) => {
                                                    return <option key={index} value={item._id}>{item.first_name}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                    {errors.client && <div className="text-danger fs-12">{errors.client}</div>}
                                </div>

                                <div className="form-group form-group-modal-custom mb-3 col-6">
                                    <label className="mb-1">
                                        <strong>Project</strong>
                                    </label>
                                    <div className="select-drop-down">
                                        <span><i class="fa fa-angle-down"></i></span>
                                        <select
                                            defaultValue={"option"}
                                            className="form-control select-control"
                                            value={project}
                                            onChange={(e) => onProjectHandler(e.target.value)}>
                                            <option value=""></option>
                                            {
                                                props.projectList.map((item, index) => {
                                                    return <option key={index} value={item._id}>{item.project_id}</option>
                                                })
                                            }
                                        </select>
                                        {errors.project && <div className="text-danger fs-12">{errors.project}</div>}
                                    </div>
                                </div>

                                <div className="form-group form-group-modal-custom mb-3 col-6">
                                    <label className="mb-1">
                                        <strong>Activity</strong>
                                    </label>
                                    <div className="select-drop-down">
                                        <span><i class="fa fa-angle-down"></i></span>
                                        <select
                                            defaultValue={"option"}
                                            className="form-control select-control"
                                            value={activity}
                                            onChange={(e) => onActivityHander(e.target.value)}>
                                            <option value=""></option>
                                            {
                                                props.activitiesList.map((item, index) => {
                                                    return <option key={index} value={item._id}>{item.activity_id}</option>
                                                })
                                            }
                                        </select>
                                        {errors.activity && <div className="text-danger fs-12">{errors.activity}</div>}
                                    </div>
                                </div>

                                <div className="form-group form-group-modal-custom mb-3 col-6">
                                    <label className="mb-1">
                                        <strong>Task</strong>
                                    </label>
                                    <div className="select-drop-down">
                                        <span><i class="fa fa-angle-down"></i></span>
                                        <select
                                            defaultValue={"option"}
                                            className="form-control select-control"
                                            value={task}
                                            onChange={(e) => setTask(e.target.value)}>
                                            <option value=""></option>
                                            {
                                                props.taskList.map((item, index) => {
                                                    return <option key={index} value={item._id}>{item.task_id}</option>
                                                })
                                            }
                                        </select>
                                        {errors.task && <div className="text-danger fs-12">{errors.task}</div>}
                                    </div>
                                </div>

                                <div className="form-group form-group-modal-custom mb-3 col-6">
                                    <label className="mb-1">
                                        <strong>Start time</strong>
                                    </label>
                                    <div className="form-calendar">
                                        <DatePicker
                                            ref={startDateRef}
                                            selected={startDate}
                                            timeInputLabel="Time:"
                                            className="form-control"
                                            placeholderText=""
                                            dateFormat="MM/dd/yyyy h:mm aa"
                                            showTimeInput
                                            onChange={(date) => setStartDate(date)}
                                        />
                                        <button type='button' className="form-calendar-btn"
                                            onClick={() => startDateRef.current.setOpen(true)}
                                        >
                                            <i class="fa-regular fa-calendar-days"></i>
                                        </button>
                                    </div>
                                    {errors.startDate && <div className="text-danger fs-12">{errors.startDate}</div>}
                                </div>

                                <div className="form-group form-group-modal-custom mb-3 col-6">
                                    <label className="mb-1">
                                        <strong>End time</strong>
                                    </label>
                                    <div className="form-calendar">
                                        <DatePicker
                                            ref={endDateRef}
                                            selected={endDate}
                                            timeInputLabel="Time:"
                                            className="form-control"
                                            placeholderText=""
                                            dateFormat="MM/dd/yyyy h:mm aa"
                                            showTimeInput
                                            onChange={(date) => setEndDate(date)}
                                        />
                                        <button type='button' className="form-calendar-btn"
                                            onClick={() => endDateRef.current.setOpen(true)}
                                        >
                                            <i class="fa-regular fa-calendar-days"></i>
                                        </button>
                                    </div>
                                    {errors.endDate && <div className="text-danger fs-12">{errors.endDate}</div>}
                                </div>

                                <div className="form-group mb-3 col-12">
                                    <label className="mb-1">
                                        <strong>Description</strong>
                                    </label>
                                    <textarea
                                        className="form-control"
                                        rows={2}
                                        //placeholder='Description'
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)} />
                                    {errors.description && <div className="text-danger fs-12">{errors.description}</div>}
                                </div>

                            </div>

                            <div className="modal-button-group mt-4">
                                <button type="button" onClick={() => setAddModal(false)} className="btn form-cencel-btn">
                                    Cancel
                                </button>
                                <button type="submit" className="btn btn-primary role-form-btn">
                                    {action == 1 ? "Add" : "Update"}
                                </button>
                            </div>
                        </form>
                    </div>

                </div>
            </Modal>

            <Modal
                className="fade bd-example-modal-sm"
                size="md"
                show={filterModal}
                onHide={() => setFilterModal(false)}
            >
                <div className="add-user-modal-form-view">
                    <button onClick={() => setFilterModal(false)} className="modal-cross-btn"><i class="fa fa-times" aria-hidden="true"></i></button>
                    <div className="modal-title-view">
                        <h3>Filter</h3>
                    </div>
                    <div className="basic-form">
                        <form onSubmit={onFilterSubmit}>
                            <div className="row">

                                <div className="form-group form-group-modal-custom mb-3">
                                    <label className="mb-1">
                                        <strong>Client</strong>
                                    </label>
                                    <div className="select-drop-down">
                                        <span><i class="fa fa-angle-down"></i></span>
                                        <select
                                            defaultValue={"option"}
                                            className="form-control select-control"
                                            value={filterClient}
                                            onChange={(e) => onFilterClientHandler(e.target.value)}>
                                            <option value=""></option>
                                            {
                                                props.clientList.map((item, index) => {
                                                    return <option key={index} value={item._id}>{item.first_name}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>

                                <div className="form-group form-group-modal-custom mb-3">
                                    <label className="mb-1">
                                        <strong>Project</strong>
                                    </label>
                                    <div className="select-drop-down">
                                        <span><i class="fa fa-angle-down"></i></span>
                                        <select
                                            defaultValue={"option"}
                                            className="form-control select-control"
                                            value={filterProject}
                                            onChange={(e) => setFilterProject(e.target.value)}>
                                            <option value=""></option>
                                            {
                                                props.projectList.map((item, index) => {
                                                    return <option key={index} value={item._id}>{item.project_id}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>

                            </div>

                            <div className="modal-button-group mt-4">
                                <button type="button" disabled={filterClient || filterProject ? false : true} onClick={() => onClearFilterHandler()} className="btn form-cencel-btn">
                                    Clear Filter
                                </button>
                                <button type="submit" disabled={filterClient || filterProject ? false : true} className="btn btn-primary role-form-btn">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>

                </div>
            </Modal>

            <Modal
                className="fade bd-example-modal-sm"
                size="md"
                show={reportModal}
                onHide={() => setReportModal(false)}
            >
                <div className="add-user-modal-form-view">
                    <button onClick={() => setReportModal(false)} className="modal-cross-btn"><i class="fa fa-times" aria-hidden="true"></i></button>
                    <div className="modal-title-view">
                        <h3>Report To</h3>
                    </div>
                    <div className="basic-form">
                        <form onSubmit={onReportSubmit}>
                            <div className="row">

                                <div className="form-group form-group-modal-custom mb-3">
                                    <label className="mb-1">
                                        <strong>Client</strong>
                                    </label>
                                    <div className="select-drop-down">
                                        <span><i class="fa fa-angle-down"></i></span>
                                        <select
                                            defaultValue={"option"}
                                            className="form-control select-control"
                                            value={reportClient}
                                            onChange={(e) => setReportClient(e.target.value)}>
                                            <option value="">Select Client</option>
                                            {
                                                props.clientList.map((item, index) => {
                                                    return <option key={index} value={item._id}>{item.first_name}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>

                            </div>

                            <div className="modal-button-group mt-4">
                                <button type="submit" className="btn btn-primary role-form-btn">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>

                </div>
            </Modal>

            <Modal
                className="fade bd-example-modal-sm"
                size="md"
                show={leaveModal}
            >
                <div className="add-user-modal-form-view">
                    <div className="modal-title-view">
                        <h3>Add Leave</h3>
                    </div>
                    <div className="basic-form">

                        <div className="row">

                            <div className="form-group form-group-modal-custom mb-3 col-6">
                                <label className="mb-1">
                                    Start Date
                                </label>
                                <div className="form-calendar">
                                    <DatePicker
                                        ref={leaveStartDateRef}
                                        selected={leaveStartDate}
                                        className="form-control"
                                        placeholderText=""
                                        onChange={(date) => setLeaveStartDate(date)}
                                    />
                                    <button type='button' className="form-calendar-btn"
                                        onClick={() => leaveStartDateRef.current.setOpen(true)}
                                    >
                                        <i class="fa-regular fa-calendar-days"></i>
                                    </button>
                                </div>
                                {leaveErrors.startDate && <div className="text-danger fs-12">{leaveErrors.startDate}</div>}
                            </div>

                            <div className="form-group form-group-modal-custom mb-3 col-6">
                                <label className="mb-1">
                                    End Date
                                </label>
                                <div className="form-calendar">
                                    <DatePicker
                                        ref={leaveEndDateRef}
                                        selected={leaveEndDate}
                                        className="form-control"
                                        placeholderText=""
                                        onChange={(date) => setLeaveEndDate(date)}
                                    />
                                    <button type='button' className="form-calendar-btn"
                                        onClick={() => leaveEndDateRef.current.setOpen(true)}
                                    >
                                        <i class="fa-regular fa-calendar-days"></i>
                                    </button>
                                </div>
                                {leaveErrors.endDate && <div className="text-danger fs-12">{leaveErrors.endDate}</div>}
                            </div>

                            <div className="form-group form-group-modal-custom mb-3 col-12">
                                <label className="mb-1">
                                    Leave type
                                </label>
                                <div className="select-drop-down">
                                    <span><i class="fa fa-angle-down"></i></span>
                                    <select
                                        class="form-control select-control"
                                        value={leaveType}
                                        onChange={(e) => setLeaveType(e.target.value)}>
                                        <option></option>
                                        {
                                            props.leaveType.map((item, index) => {
                                                return <option key={index} value={item._id}>{item.title}</option>
                                            })
                                        }
                                    </select>
                                </div>
                                {leaveErrors.type && <div className="text-danger fs-12">{leaveErrors.type}</div>}
                            </div>
                            <div className="form-group form-group-modal-custom mb-3 col-12">
                                <label className="mb-1">
                                    Description
                                </label>
                                <input className="form-control" value={leaveDescription} onChange={(e) => setLeaveDescription(e.target.value)} />
                            </div>

                        </div>

                        <div className="modal-button-group mt-4">
                            <button type="button" onClick={() => setLeaveModal(false)} className="btn form-cencel-btn">
                                Close
                            </button>
                            <button type="button" className="btn btn-primary role-form-btn" onClick={() => onSubmitLeaveHandler()}>
                                Submit
                                {loadingLeave ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    : null}
                            </button>

                        </div>

                    </div>

                </div>
            </Modal>

            <DateRangeModal
                show={isDateRange}
                onClose={() => setIsDateRange(false)}
            />
            <SheetReviewModal
                title={"Are you soure ?"}
                description={"you want to add time"}
                show={reviewModal}
                onClose={() => onReviewCloseHandler()}
                onSubmit={onFinalSubmitHandler}
            />
            <ChatBox
                show={isNote}
                data={noteData}
                value={message}
                onChangeHandler={(val) => setMessage(val)}
                onSubmitHandler={() => onSubmitMessageHandler()}
                closeHandler={closeHandler}
                loading={loading}
                currentUser={props.userId}
            />
            <AddReportManual
                show={manualModal}
                data={{ project: filterProject }}
                action={1}
                submitHandler={(data) => onManualSubmitHandler(data)}
                closeHandler={() => setManualModal(false)}
            />
            {/* <Modal
                className="fade bd-example-modal-sm"
                size="lg"
                show={false}
            >
              <ViewPDF data={props.details?.data} />
            </Modal> */}
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        screenVisible: state.clients.screenVisible,
        showLoading: state.clients.showLoading,
        clientList: state.clients.clientList,
        projectList: state.project.projectList,
        activitiesList: state.project.activitiesList,
        taskList: state.project.taskList,
        countryList: state.country.countryList,
        timeCardDetails: state.timeCard.generateDetails,
        configDetails: state.systemconfig.configDetails,
        configWeeks: state.systemconfig.weekConfig,
        configLeave: state.systemconfig.leaveConfig,
        systemAdmin: state.auth.systemAdmin,
        projectDetails: state.project.projectDetails,
        userId: state.auth.userId,
        employeeList: state.employee.projectEmployeeList,
        leaveType: state.leave.leaveType,
        calendarLeave: state.leave.calendarLeave,
    };
};
export default connect(mapStateToProps)(ReportTo);